import React from 'react';
import { styled } from '@mui/material';

interface StatusDotProps {
    color: string;
    size?: number;
}

export function StatusDot({ color, size = 10 }: StatusDotProps) {
    return <Dot $color={color} $size={size} />;
}

const Dot = styled('div', { shouldForwardProp: (p) => p !== '$color' && p !== '$size' })<{
    $color: string;
    $size: number;
}>(({ $color, $size }) => ({
    width: $size,
    height: $size,
    borderRadius: '50%',
    backgroundColor: $color,
    flexShrink: 0,
}));
